import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import FMPText from '../pureForm/FMPText';
import FuelMaintenanceCostContainer from '../../containers/inventory/FuelMaintenanceCost';
import Transition from './Transition';
import FormComponent from '../FormComponent';
import moment from 'moment';
import async from 'async';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	submitButton: {
		fontSize: 16,
		borderRadius: '100px',
		padding: '15px 20px',
		textTransform: 'uppercase',
	},
	addInputButton: {
		borderRadius: '100px',
		marginTop: 20,
	},
	attachment: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		border: '1px solid #ddd',
	},
	emailBody: {
		border: '1px solid #ddd',
	},
	invoiceDocuments: {
		display: 'flex',
		flexWrap: 'wrap',
		alignContent: 'stretch',
		justifyContent: 'space-between',
		marginTop: 20,
	},
	invoicePage: {
		width: '33%',
		padding: 5,
		boxSizing: 'border-box',
	},
	invoicePageImg: {
		width: '100%',
		height: '100%',
		border: '1px solid #ddd',
	},
	pageSection: {
		borderBottom: '2px dashed #ccc',
		marginBottom: 30,
		paddingBottom: 30,
	},
});

class SaveFuelMaintenanceCostDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			vendorBillId: undefined,
			additionalInvoiceEmails: [],
			formFieldError: {},
			emailNote: '',
			isSaving: false,
			savingStatus: undefined,
			isUpdate: false,
			savingSuccessful: false,
		};
	}

	componentDidUpdate(prevProps) {
		const { fuelMaintenanceCost, open } = this.props;
		//- Every time it opens figure out if its an update and update teh form
		if (!prevProps.open && open) {
			if (fuelMaintenanceCost) {
				const newState = this.fillForm();
				newState.isUpdate = true;
				this.setState(newState);
			}
		}
	}

	fillForm = () => {
		const { fuelMaintenanceCost } = this.props;
		if (!fuelMaintenanceCost) {
			return;
		}

		const newState = {};
		['fuelMaintenanceCostId', 'cost', 'description'].forEach((key) => {
			if (_.isNil(fuelMaintenanceCost[key])) {
				return;
			}
			newState[key] = fuelMaintenanceCost[key];
		});
		return newState;
	};

	handleClose = () => {
		this.setState(
			{
				isSaving: false,
				savingSuccessful: false,
				cost: '',
				description: '',
			},
			this.props.onClose
		);
	};

	handleSave = () => {
		const { showErrors, addFuelMaintenanceCost, updateFuelMaintenanceCost } = this.props;
		const { isUpdate, fuelMaintenanceCostId } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { inventoryAllocationId, yearMonth } = this.props;
		const { description } = this.state;

		let cost = this.state.cost;
		if (cost && _.isString(cost)) {
			cost = parseFloat(cost.replace(/,/g, ''), 10);
		}

		if (!_.isNumber(cost)) {
			formFieldError.cost = 'Number of gallons must be a number';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const yearMonthMoment = moment(yearMonth);

		const params = {
			assignedToInventoryAllocationId: inventoryAllocationId,
			year: yearMonthMoment.year(),
			month: yearMonthMoment.month(),
			cost,
			description,
		};

		this.setState({
			isSaving: true,
		});

		async.waterfall(
			[
				(callback) => {
					if (!isUpdate) {
						addFuelMaintenanceCost({
							params,
							callback,
						});
					} else {
						params.fuelMaintenanceCostId = fuelMaintenanceCostId;
						updateFuelMaintenanceCost({
							params,
							callback,
						});
					}
				},
			],
			(err) => {
				if (err) {
					this.setState({
						isSaving: false,
					});
					return showErrors([err]);
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});
				}, 500);
			}
		);
	};

	render() {
		const { classes, open, inventoryAllocationId, fullScreen } = this.props;
		const { isUpdate, isSaving, savingSuccessful } = this.state;
		if (!inventoryAllocationId) {
			return null;
		}

		const action = isUpdate ? 'Update Fuel Maintenance Cost' : 'Add Fuel Maintenance Cost';
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>{action}</DialogTitle>
					<DialogContent>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Grid container spacing={2}>
									<FMPText {...this.setForm(`cost`, 'Total Cost', true)} />

									<FMPText {...this.setForm(`description`, 'Description of Cost', true)} />
								</Grid>
							</Grid>
							<Grid item xs={12}>
								Note : After new fuel maintenance costs are added allocation will need to reload to
								calculate the new blended costs and show the maintenance costs.
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div>
							<Zoom
								in={isSaving}
								style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
								mountOnEnter
								unmountOnExit
							>
								<div className={classes.isSaving}>
									<CircularProgress style={{ verticalAlign: 'middle' }} />
									<span style={{ paddingLeft: 10 }}>Saving...</span>
								</div>
							</Zoom>

							<Zoom
								in={savingSuccessful}
								style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
							>
								<div className={classes.savingSuccessful}>
									<div className={classes.greenCheckedIcon} />
									<span style={{ paddingLeft: 10 }}>Save Successful. </span>
									<Button
										variant="outlined"
										color="primary"
										onClick={() => {
											const { history } = this.props;
											history.go();
										}}
									>
										Reload
									</Button>
								</div>
							</Zoom>
						</div>

						<div>
							<Button onClick={this.handleClose}>Cancel</Button>
							<Button
								disabled={isSaving}
								variant="contained"
								onClick={this.handleSave}
								className={classes.submitButton}
								color="primary"
							>
								Save Cost
							</Button>
						</div>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

SaveFuelMaintenanceCostDialog.propTypes = {
	inventoryAllocationId: PropTypes.string,
	fuelMaintenanceCost: PropTypes.object,
	addFuelMaintenanceCost: PropTypes.func.isRequired,
	updateFuelMaintenanceCost: PropTypes.func.isRequired,

	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors: PropTypes.func,
	history: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog(), FuelMaintenanceCostContainer])(
	SaveFuelMaintenanceCostDialog
);
